import Vue from "vue";
import VueRouter from "vue-router";
import waitFor from "@/utils/waitFor";
import store from "@/store";
import tests from "@/router/tests/tests";
import notFound from "@/router/tests/not-found";
import policies from "@/router/tests/policies";

Vue.use(VueRouter);

const routes = [...tests, ...notFound];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach(async (to, from, next) => {
  // state
  await waitFor(() => store.getters["isInitialized"]);

  // policies
  policies.run(to, from, next);
});

export default router;
